module.exports = __webpack_public_path__ + "static/media/External Misc.e3a23ad5.csv";